import { useNavigate, useSearch } from '@tanstack/react-router';

import type { AdsTxtDomainStatus } from './model';
import {
  parseAdsTxtDomainsRouteSearch,
  serializeAdsTxtDomainsRouteSearch,
} from './adsTxtDomainsRouteSearch';

export function useAdsTxtDomainsRouteFilters() {
  const navigate = useNavigate({ from: '/supply/ads-txt/domains' });
  const search = useSearch({ from: '/supply/ads-txt/domains' });
  const filter = parseAdsTxtDomainsRouteSearch(search);
  const update = (next: typeof filter) =>
    void navigate({ search: serializeAdsTxtDomainsRouteSearch(next), replace: true });
  return {
    filter,
    setSearch: (searchTerm: string) => {
      update({ ...filter, searchTerm, page: 0 });
    },
    setStatuses: (statuses: AdsTxtDomainStatus[]) => {
      update({ ...filter, statuses, page: 0 });
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
  };
}
